module.exports = __webpack_public_path__ + "img/w6.4dbbd8ae.jpg";